document.addEventListener('DOMContentLoaded', function () {
  initReveal();
  initScrollToForm();
  initCountdown();
});

function initReveal() {
  var els = document.querySelectorAll('.cy-reveal');
  if (!els.length) return;
  if (!('IntersectionObserver' in window)) {
    els.forEach(function (el) { el.classList.add('cy-visible'); });
    return;
  }
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        var delay = entry.target.getAttribute('data-cy-delay') || 0;
        setTimeout(function () { entry.target.classList.add('cy-visible'); }, Number(delay));
        io.unobserve(entry.target);
      }
    });
  }, { threshold: 0.15, rootMargin: '0px 0px -60px 0px' });
  els.forEach(function (el) { io.observe(el); });
}

function initScrollToForm() {
  document.querySelectorAll('[data-cy-scroll-to-form]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var target = document.getElementById('cy-form');
      if (target) target.scrollIntoView({ behavior: 'smooth', block: 'center' });
    });
  });
}

/* Countdown: solo se activa si hay una fecha real configurada en la sección.
   Puede haber más de una instancia en la página (versión desktop + mobile). */
function initCountdown() {
  document.querySelectorAll('[data-cy-countdown]').forEach(function (el) {
    var targetDate = el.getAttribute('data-cy-countdown');
    if (!targetDate) return;
    var target = new Date(targetDate).getTime();
    if (isNaN(target)) return;

    var daysEl = el.querySelector('[data-cy-days]');
    var hoursEl = el.querySelector('[data-cy-hours]');
    var minEl = el.querySelector('[data-cy-min]');
    var secEl = el.querySelector('[data-cy-sec]');

    function tick() {
      var now = Date.now();
      var diff = target - now;
      if (diff <= 0) {
        el.hidden = true;
        clearInterval(timer);
        return;
      }
      var days = Math.floor(diff / 86400000);
      var hours = Math.floor((diff % 86400000) / 3600000);
      var mins = Math.floor((diff % 3600000) / 60000);
      var secs = Math.floor((diff % 60000) / 1000);
      if (daysEl) daysEl.textContent = String(days).padStart(2, '0');
      if (hoursEl) hoursEl.textContent = String(hours).padStart(2, '0');
      if (minEl) minEl.textContent = String(mins).padStart(2, '0');
      if (secEl) secEl.textContent = String(secs).padStart(2, '0');
    }

    el.hidden = false;
    tick();
    var timer = setInterval(tick, 1000);
  });
}
